'use client';

import { type OpenCheckoutSheetOptions, useGlobalSheet } from '../global-sheets/context/GlobalSheetContext';
import { usePendingCheckout } from './hooks/usePendingCheckout';

type CheckoutProviderProps = {
  children: React.ReactNode;
};

function CheckoutProvider({ children }: CheckoutProviderProps) {
  const { openCheckoutSheet } = useGlobalSheet();

  usePendingCheckout({
    onPendingCheckout: storedData => {
      if (!storedData) return;
      void openCheckoutSheet(storedData as OpenCheckoutSheetOptions);
    },
  });

  return <>{children}</>;
}

export { CheckoutProvider };
